import React, { Ref, useMemo } from 'react';
import classnames from 'classnames';
import { v4 as uuid } from 'uuid';
import RadioButton from './RadioButton';
import { RadioButtonLabel } from './RadioButtonLabel';
import ErrorMessageLabel from './ErrorMessageLabel';
import '@eika/radio-button-style';

export interface RadioButtonProps {
    label: string;
    id?: string;
    onChange: (value: string) => void;
    options: {
        value: string;
        label?: string;
        id?: string;
        ref?: Ref<HTMLInputElement>;
    }[];
    selectedOption: string | undefined;
    className?: string;
    sublabel?: string;
    name?: string;
    errorMessage?: string;
    required?: boolean;
    horizontal?: boolean;
    infoButton?: React.ReactNode;
    externalLinkLabel?: React.ReactNode;
}

const RadioButtons = ({
    className,
    selectedOption,
    options,
    onChange,
    name,
    label,
    id,
    sublabel,
    infoButton,
    externalLinkLabel,
    errorMessage,
    required = false,
    horizontal = false,
}: RadioButtonProps): JSX.Element => {
    const errorId = useMemo<string>(() => id || uuid(), [id]);

    return (
        <fieldset className={classnames('sgw-radio-button', className)}>
            <RadioButtonLabel
                label={label}
                sublabel={sublabel}
                infoButton={infoButton}
                externalLinkLabel={externalLinkLabel}
            />
            <div className={classnames({ 'sgw-radio-button__horizontal': horizontal })}>
                {options.map((option) => (
                    <RadioButton
                        value={option.value}
                        selectedOption={selectedOption}
                        onChange={onChange}
                        label={option.label}
                        id={option.id}
                        name={name}
                        describedBy={errorId}
                        required={required}
                        error={!!errorMessage}
                        inputRef={option.ref}
                        key={option.value}
                    />
                ))}
            </div>
            <ErrorMessageLabel errorMessage={errorMessage} errorId={errorId} />
        </fieldset>
    );
};

export default RadioButtons;
